import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import queryString from "query-string";

// Components
import ProductList from "../ProductList";
import SortOptions from "../utils/sort-options/SortOptions";

// Utils
import { defaultSortOptions } from "../../utils/sorting";

class ViewAll extends Component {
	render() {
		return (
			<div className="centered">
				<Link className="view_all" to={`/category/${this.props.permalink}`}>
					View All
				</Link>
			</div>
		);
	}
}

class CategoryList extends Component {
	handlePaginationChange(data) {
		// The page number selected
		const selected = data.selected;

		// Get any other query objects
		let queryObj = {};
		const query = !!this.props.location ? queryString.parse(this.props.location.search) : {};
		const q = !!query.q ? query.q : "";
		if (!!q) queryObj.q = q;

		const sort = !!query.sort ? query.sort : "";
		if (!!sort) queryObj.sort = sort;

		const dir = !!query.dir ? query.dir : "";
		if (!!dir) queryObj.dir = dir;

		queryObj.pg = selected;

		// Make a valid url string (pg=2&q=cow, etc)
		const qs = queryString.stringify(queryObj);

		// Push to history. componentWillReceiveProps() will take care of triggering the search
		this.props.history.push("?" + qs);
	}

	render() {
		const { category } = this.props;
		const { results } = category;
		const { items } = results;

		// If this categories array exists, this is not the top-most category and we won't be showing the "View All" button
		const subCats = !!category.categories;

		return (
			<div className="category_section">
				<h2>{category.title}</h2>

				{subCats &&
					results.total_pages > 1 && (
						<ReactPaginate
							previousLabel={""}
							previousLinkClassName={"icon-previous"}
							nextLabel={""}
							nextLinkClassName={"icon-next"}
							breakLabel={<a href="">...</a>}
							breakClassName={"break-me"}
							pageCount={results.total_pages}
							disableInitialCallback={true}
							initialPage={
								results.current_page < 1
									? results.current_page
									: results.current_page - 1
							}
							marginPagesDisplayed={2}
							pageRangeDisplayed={4}
							onPageChange={this.handlePaginationChange.bind(this)}
							containerClassName={"pagination"}
							subContainerClassName={"pages pagination"}
							activeClassName={"active"}
						/>
					)}

				{
					<SortOptions
						options={defaultSortOptions}
						isAjax={items && !subCats}
						collectionIndex={this.props.catIndex}
						{...this.props}
					/>
				}

				<div className="product_collection">
					{items ? (
						<ProductList products={items} isChild={true} />
					) : (
						`Check back for the latest ${category.title} products!`
					)}
				</div>

				{items && !subCats ? <ViewAll permalink={category.permalink} /> : null}

				{subCats &&
					results.total_pages > 1 && (
						<ReactPaginate
							previousLabel={""}
							previousLinkClassName={"icon-previous"}
							nextLabel={""}
							nextLinkClassName={"icon-next"}
							breakLabel={<a href="">...</a>}
							breakClassName={"break-me"}
							pageCount={results.total_pages}
							disableInitialCallback={true}
							initialPage={
								results.current_page < 1
									? results.current_page
									: results.current_page - 1
							}
							marginPagesDisplayed={2}
							pageRangeDisplayed={4}
							onPageChange={this.handlePaginationChange.bind(this)}
							containerClassName={"pagination"}
							subContainerClassName={"pages pagination"}
							activeClassName={"active"}
						/>
					)}
			</div>
		);
	}
}

export default withRouter(CategoryList);



// WEBPACK FOOTER //
// ./src/components/category/CategoryList.js